import debug from 'debug';

export default debug('@openzeppelin:upgrades:core');
